const BACKEND_URL = import.meta.env.BACKEND_URL?.replace(/\/$/, '');

const ALL_AUTH_METHODS = ['sso-km', 'sso-ldt', 'password'] as const;
export type AuthMethod = (typeof ALL_AUTH_METHODS)[number];

export type Config = {
    debug: boolean;
    envName: string;
    showEnvName: boolean;
    graphqlUrl: string;
    versionJsonUrl: string;
    trpcServerUrl: string;
    sentryDsn: string;
    authMethods: AuthMethod[];
};

function deriveAuthMethods(): AuthMethod[] {
    const methods: AuthMethod[] = ['password'];

    if (import.meta.env.ENTRA_KM_TENANT_ID && import.meta.env.ENTRA_KM_CLIENT_ID) {
        methods.push('sso-km');
    }
    if (import.meta.env.ENTRA_LDT_TENANT_ID && import.meta.env.ENTRA_LDT_CLIENT_ID) {
        methods.push('sso-ldt');
    }
    return methods;
}

export const config: Config = {
    debug: String(import.meta.env.DEBUG).toLowerCase() === 'true',
    envName: import.meta.env.ENV_NAME,
    showEnvName: String(import.meta.env.SHOW_ENV_NAME).toLowerCase() === 'true',
    graphqlUrl: `${BACKEND_URL}/graphql`,
    versionJsonUrl: `${BACKEND_URL}/version.json`,
    trpcServerUrl: `${BACKEND_URL}/trpc`,
    sentryDsn: import.meta.env.SENTRY_DSN,
    authMethods: deriveAuthMethods(),
};
